import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

function PasswordInput({
    ref,
    className,
    ...props
}: React.ComponentProps<"input"> & { ref?: React.Ref<HTMLInputElement> }) {
    const [showPassword, setShowPassword] = useState(false);
    return (
        <div className="relative">
            <Input
                ref={ref}
                className={cn("h-10 pr-10", className)}
                {...props}
                type={showPassword ? "text" : "password"}
            />
            <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                className="text-muted-foreground absolute top-1/2 right-1 -translate-y-1/2"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
            >
                {showPassword ? <EyeOff /> : <Eye />}
            </Button>
        </div>
    );
}

export { PasswordInput };
